import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Flex, Text, Box, Paragraph } from "@zillow/constellation";
import { useLastValidHomeSaleProceedsCalculator, FieldConfig } from "./HomeSaleProceedsCalculator.utils.esm.js";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
const HomeSaleProceedsContent = () => {
  const lastValidHomeSaleProceedsCalculator = useLastValidHomeSaleProceedsCalculator();
  const {
    estimatedSellingCostResult,
    estimatedNetProceeds,
    estimatedSellingCostPercentage
  } = lastValidHomeSaleProceedsCalculator.calculations;
  const {
    desiredSellingPrice,
    remainingMortgageOwed
  } = lastValidHomeSaleProceedsCalculator.fields;
  const OUTPUTS = useMemo(() => [{
    label: "Desired selling price",
    accessor: FieldConfig.desiredSellingPrice.name
  }, {
    label: "Remaining mortgage owed",
    accessor: FieldConfig.remainingMortgageOwed.name
  }, {
    label: `Est. selling costs (${estimatedSellingCostPercentage.toFixed(2)}%)`,
    accessor: FieldConfig.estimatedSellingCost.name
  }], [estimatedSellingCostPercentage]);
  return /* @__PURE__ */ jsxs(Flex, { flex: "1", alignItems: "center", display: "flex", justifyContent: "center", flexDirection: "column", "aria-live": "polite", "aria-atomic": "true", width: "100%", children: [
    /* @__PURE__ */ jsx(Text, { fontType: "h4", as: "h2", fontWeight: "normal", children: "Estimated net proceeds" }),
    /* @__PURE__ */ jsxs(Text, { style: {
      display: "block"
    }, fontType: "h2", fontColor: "green500", margin: "md", children: [
      "$",
      commaSeparateNumber(estimatedNetProceeds)
    ] }),
    OUTPUTS.map(({
      label,
      accessor
    }, index) => /* @__PURE__ */ jsxs(Box, { as: Flex, display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "sm", marginBottom: "sm", sx: {
      flexDirection: "row",
      borderBottom: index !== OUTPUTS.length - 1 ? "1px solid $colors.gray300" : void 0,
      width: "80%"
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { fontType: "body", children: label }),
      accessor === FieldConfig.estimatedSellingCost.name ? /* @__PURE__ */ jsxs(Text, { fontType: "bodyHeading", children: [
        "$",
        commaSeparateNumber(estimatedSellingCostResult)
      ] }) : accessor === FieldConfig.remainingMortgageOwed.name ? /* @__PURE__ */ jsxs(Text, { fontType: "bodyHeading", children: [
        "$",
        commaSeparateNumber(remainingMortgageOwed)
      ] }) : /* @__PURE__ */ jsxs(Text, { fontType: "bodyHeading", children: [
        "$",
        commaSeparateNumber(desiredSellingPrice)
      ] })
    ] }, accessor))
  ] });
};
export {
  HomeSaleProceedsContent as default
};
